import { useQuery } from '@tanstack/react-query';

import { AccountsApi } from '../../apis';
import { AccountsFilter, AccountStatus } from '../../models/accounts';
import { QueryKeys } from '../query-keys';

const useAccountsSummary = (
  filter: AccountsFilter = { status: AccountStatus.ACTIVE }
) => {
  const query = useQuery({
    queryKey: [QueryKeys.ACCOUNTS, 'summary', filter],
    queryFn: () => AccountsApi.getSummary(filter),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    summary: query.data || {
      accountsCount: 0,
      totalBalance: 0,
      balancesByAccountType: [],
    },
  };
};

export default useAccountsSummary;
